var CandidateCard = /** @class */ (function () {
    function CandidateCard() {
        this.id = null;
        this.name;
        this.firstName;
        this.lastName;
        this.candidateStatus;
        this.workphone;
        this.mobilephone;
        this.email;
        this.im;
        this.noOfDaysSinceLastContact;
        this.bestMatchJobId;
        this.bestMatchJobTitle;
        this.bestMatchJobDate;
        this.bestMatchRequisitionNum;
        this.bestMatchJobScore;
        this.bestMatchClientName;
        this.bestMatchRecruiterName;
        this.bestMatchJobCurrentState;
        this.currentJobCompanyName;
        this.currentJobDuration;
        this.currentJobLocation;
        this.currentJobTitle;
        this.noOfDaysSinceLastUpload;
        this.noOfDaysSinceAdded;
        this.jobMatchesCount;
        this.recruiterList = [];
        this.vendorName;
        this.candidateFilledOrJoinedToOwnJob;
        this.candidateActive;
        this.candidatePassive;
        this.candidateInert;
        this.showUploadResumeAction;
        this.workLocations;
    }
    return CandidateCard;
}());
export { CandidateCard };
//# sourceMappingURL=candidateCard.js.map